<template>
  <div>
    <!-- ***** Welcome Area Start ***** -->
    <section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <!-- Welcome Intro Start -->
          <div class="col-12 col-md-7 col-lg-6">
            <div class="welcome-intro">
              <h2 class="text-white text-uppercase">Don’t Let your assets sit idle</h2>
              <p class="text-white my-4">
                Bantain is one of the world leading staking companies offering the best staking rewards and crypto growth tools. We are currently staking over 200 yield bearing assets in our pools with an average APY of 46.15%
              </p>
              <!-- Store Buttons -->
              <div class="button-group store-buttons d-flex">
                <a href="/desktop" target="_self" class="btn btn-bordered mt-4">Go to Wallet</a>
                <!--                            <a href="#">-->
                <!--                                <img src="../../assets/parent/img/icon/google-play.png" alt="">-->
                <!--                            </a>-->
                <!--                            <a href="#">-->
                <!--                                <img src="../../assets/parent/img/icon/app-store.png" alt="">-->
                <!--                            </a>-->
              </div>
              <span class="d-inline-block text-white fw-3 font-italic mt-3">* Best viewed on mobile devices</span>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-6">
            <!-- Welcome Thumb -->
            <div class="welcome-thumb mx-auto" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
              <img src="../../assets/parent/img/welcome/welcome-mockup.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- Shape Bottom -->
      <div class="shape-bottom">
        <svg viewBox="0 0 1920 310" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="svg replaced-svg">
          <!--                <title>sApp Shape</title>-->
          <!--                <desc>Created with Sketch</desc>-->
          <defs></defs>
          <g id="sApp-Landing-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="sApp-v1.0" transform="translate(0.000000, -554.000000)" fill="#FFFFFF">
              <path d="M-3,551 C186.257589,757.321118 319.044414,856.322454 395.360475,848.004007 C509.834566,835.526337 561.525143,796.329212 637.731734,765.961549 C713.938325,735.593886 816.980646,681.910577 1035.72208,733.065469 C1254.46351,784.220361 1511.54925,678.92359 1539.40808,662.398665 C1567.2669,645.87374 1660.9143,591.478574 1773.19378,597.641868 C1848.04677,601.75073 1901.75645,588.357675 1934.32284,557.462704 L1934.32284,863.183395 L-3,863.183395" id="sApp-v1.0"></path>
            </g>
          </g>
        </svg>
      </div>
    </section>
    <!-- ***** Welcome Area End ***** -->

    <!-- ***** Counter Area Start ***** -->
    <section class="section counter-area ptb_50">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-5 col-sm-3 single-counter text-center">
            <div class="counter-inner p-3 p-md-0">
              <!-- Counter Item -->
              <div class="counter-item d-inline-block mb-3">
                <span class="counter fw-7">10</span><span class="fw-7">M</span>
              </div>
              <h5>Users</h5>
            </div>
          </div>
          <div class="col-5 col-sm-3 single-counter text-center">
            <div class="counter-inner p-3 p-md-0">
              <!-- Counter Item -->
              <div class="counter-item d-inline-block mb-3">
                <span class="counter fw-7">23</span><span class="fw-7">K</span>
              </div>
              <h5>Shipped</h5>
            </div>
          </div>
          <div class="col-5 col-sm-3 single-counter text-center">
            <div class="counter-inner p-3 p-md-0">
              <!-- Counter Item -->
              <div class="counter-item d-inline-block mb-3">
                <span class="counter fw-7">12</span><span class="fw-7">B+</span>
              </div>
              <h5>Assets</h5>
            </div>
          </div>
          <div class="col-5 col-sm-3 single-counter text-center">
            <div class="counter-inner p-3 p-md-0">
              <!-- Counter Item -->
              <div class="counter-item d-inline-block mb-3">
                <span class="counter fw-7">1</span><span class="fw-7">B+</span>
              </div>
              <h5>Auto Stake</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ***** Counter Area End ***** -->

    <!--        <section class="section download-area overlay-dark custom ptb_100" :style="{backgroundImage: 'url('+coinsImg+')'}">-->
    <!--            <div class="container">-->
    <!--                <div class="row justify-content-center">-->
    <!--                    <div class="col-12 col-md-10 col-lg-9">-->
    <!--                        &lt;!&ndash; Download Text &ndash;&gt;-->
    <!--                        <div class="download-text text-center" style="height: 150px">-->

    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </section>-->

    <!-- ***** Features Area Start ***** -->
    <section id="features" class="section features-area style-two overflow-hidden ptb_50">
      <div class="container">

        <!-- Section Heading -->
        <div class="row align-items-end justify-content-between mb-5">
          <div class="col-12 col-lg-6">
            <span class="features-badge mb-3 d-inline-flex align-items-center gap-2">
              <ion-icon name="flash-outline"></ion-icon>
              Premium Features
            </span>
            <h2 class="features-heading">
              What Makes<br>
              <span class="features-heading-accent">Bantain</span> Different?
            </h2>
          </div>
          <div class="col-12 col-lg-5 mt-3 mt-lg-0">
            <p class="features-sub">
              We've built a platform that puts your crypto to work from day one —
              low barriers, automated rewards, and institutional-grade staking in your pocket.
            </p>
            <div class="features-stat-row">
              <div class="features-stat">
                <span class="features-stat-num">$1</span>
                <span class="features-stat-label">Minimum to earn</span>
              </div>
              <div class="features-stat-divider"></div>
              <div class="features-stat">
                <span class="features-stat-num">90d</span>
                <span class="features-stat-label">Staking period</span>
              </div>
              <div class="features-stat-divider"></div>
              <div class="features-stat">
                <span class="features-stat-num">Auto</span>
                <span class="features-stat-label">Reward payouts</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Feature Cards -->
        <div class="row g-4">
          <div class="col-12 col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
            <div class="image-box icon-1 feat-card h-100">
              <div class="feat-number">01</div>
              <div class="feat-icon-wrap mb-4">
                <ion-icon name="layers-outline"></ion-icon>
              </div>
              <h3 class="feat-title">More Assets.<br>More Rewards.</h3>
              <p class="feat-desc">
                Earn rewards with as little as $1 in crypto. The more you hold, the more you earn — across a growing list of supported assets.
              </p>
              <div class="feat-footer">
                <span class="feat-tag">Multi-asset</span>
                <span class="feat-tag">Low entry</span>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.25s">
            <div class="image-box icon-1 feat-card feat-card--highlight h-100">
              <div class="feat-number">02</div>
              <div class="feat-icon-wrap mb-4">
                <ion-icon name="trending-up-outline"></ion-icon>
              </div>
              <h3 class="feat-title">Earn<br>Automatically.</h3>
              <p class="feat-desc">
                Put your crypto to work and walk away. Rewards appear in your account periodically — no manual claiming, no complexity.
              </p>
              <div class="feat-footer">
                <span class="feat-tag">Passive income</span>
                <span class="feat-tag">Periodic payouts</span>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
            <div class="image-box icon-1 feat-card h-100">
              <div class="feat-number">03</div>
              <div class="feat-icon-wrap mb-4">
                <ion-icon name="lock-closed-outline"></ion-icon>
              </div>
              <h3 class="feat-title">Auto<br>Staking.</h3>
              <p class="feat-desc">
                Lock any crypto asset for 90 days and earn staking rewards. One-click setup, minimum requirements, maximum returns.
              </p>
              <div class="feat-footer">
                <span class="feat-tag">90-day lock</span>
                <span class="feat-tag">Max returns</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
    <!-- ***** Features Area End ***** -->

    <!-- ***** Service Area Start ***** -->
    <section class="section service-area bg-gray overflow-hidden ptb_100">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-12 col-lg-6 order-2 order-lg-1">
            <!-- Service Text -->
            <div class="service-text pt-4 pt-lg-0">
              <h2 class="text-capitalize mb-4">What is staking?</h2>
              <!-- Service List -->
              <ul class="service-list">
                <!-- Single Service -->
                <li class="single-service media py-2">
                  <div class="service-icon pr-4">
                    <span><i class="fab fa-buffer"></i></span>
                  </div>
                  <div class="service-text media-body">
                    <p>
                      The first thing you have to know about staking is staking/staking rewards aren’t investments so there is ZERO risk. Crypto staking is a process used to verify cryptocurrency transactions. It involves committing holdings to support a blockchain network and confirm the transactions. It also allows participants to earn passive income on their holdings…. this is because the blockchain puts your holding to work
                    </p>
                  </div>
                </li>
                <!-- Single Service -->
                <li class="single-service media py-2">
                  <div class="service-icon pr-4">
                    <span><i class="fas fa-brush"></i></span>
                  </div>
                  <div class="service-text media-body">
                    <p>
                      Earn passive income with crypto. Safe and secure staking. Up to 60% APY on all your assets, risk free…..Earn more by holding assets that generate rewards. We’re adding more assets all the time too
                    </p>
                  </div>
                </li>
                <!-- Single Service -->
                <li class="single-service media py-2">
                  <div class="service-icon pr-4">
                    <span><i class="fas fa-burn"></i></span>
                  </div>
                  <div class="service-text media-body">
                    <p>
                      Staking your own crypto is a challenge for most investors. To stake on your own requires running a node on your own hardware, syncing it to the blockchain, and funding the node with enough cryptocurrency to meet minimum thresholds, including providing a sizable deposit and bond. On Bantain, we do all this for you. While Bantain stakes, generates and signs blocks on your behalf, you retain full ownership of your tokens and earn rewards
                    </p>
                  </div>
                </li>
                <!-- Single Service -->
                <li class="single-service media py-2">
                  <div class="service-icon pr-4">
                    <span><i class="fas fa-lock"></i></span>
                  </div>
                  <div class="service-text media-body">
                    <p>
                      We Don’t Compromise on Security. User security is our top priority Never reveal your recovery seeds to anyone including Bantain employees. We will never ask you about it
                    </p>
                  </div>
                </li>
              </ul>
              <a href="/desktop" target="_self" class="btn btn-bordered mt-4">Go to Wallet</a>
            </div>
          </div>
          <div class="col-12 col-lg-4 order-1 order-lg-2 d-none d-lg-block">
            <!-- Service Thumb -->
            <div class="service-thumb mx-auto">
              <img src="../../assets/parent/img/features/thumb-2.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ***** Service Area End ***** -->


    <!-- ***** Work Area Start ***** -->
    <section class="section work-area bg-overlay overflow-hidden ptb_100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8">
            <!-- Work Content -->
            <div class="work-content text-center">
              <h2 class="text-white">Get started in just a few minutes</h2>
              <!--                        <p class="d-none d-sm-block text-white my-3 mt-sm-4 mb-sm-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.</p>-->
              <!--                        <p class="d-block d-sm-none text-white my-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p>-->
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-4">
            <!-- Single Work -->
            <div class="single-work text-center p-3">
              <!-- Work Icon -->
              <div class="work-icon">
                <img class="avatar-md" src="../../assets/parent/img/icon/work/download.png" alt="">
              </div>
              <h3 class="text-white py-3">Sign up</h3>
              <p class="text-white">
                Get started with your referees link, deposit any asset and securely store or stake it in your Bantain wallet with just a few clicks
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <!-- Single Work -->
            <div class="single-work text-center p-3">
              <!-- Work Icon -->
              <div class="work-icon">
                <img class="avatar-md" src="../../assets/parent/img/icon/work/settings.png" alt="">
              </div>
              <h3 class="text-white py-3">Deposit</h3>
              <p class="text-white">
                Quickly generate a unique address on all your assets to top up your Bantain wallet and get started
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <!-- Single Work -->
            <div class="single-work text-center p-3">
              <!-- Work Icon -->
              <div class="work-icon">
                <img class="avatar-md" src="../../assets/parent/img/icon/work/app.png" alt="">
              </div>
              <h3 class="text-white py-3">Referral</h3>
              <p class="text-white">
                As our valued user you earn a percentage
                anytime a new user registers and deposits with your referral link
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ***** Work Area End ***** -->

    <!-- ***** FAQ Area Start ***** -->
    <section class="section faq-area style-two ptb_100">
      <div class="container">

        <!-- Header row -->
        <div class="row align-items-end justify-content-between mb-5">
          <div class="col-12 col-lg-6">
            <span class="features-badge mb-3 d-inline-flex align-items-center gap-2">
              <ion-icon name="help-circle-outline"></ion-icon>
              Got Questions?
            </span>
            <h2 class="features-heading">
              Frequently<br>
              <span class="features-heading-accent">Asked</span> Questions
            </h2>
          </div>
          <div class="col-12 col-lg-5 mt-3 mt-lg-0">
            <p class="features-sub">
              Everything you need to know about staking, rewards, and how Bantain works.
              Can't find your answer? <a href="#contact" class="faq-contact-link">Contact our team.</a>
            </p>
          </div>
        </div>

        <!-- Accordion -->
        <div class="row">
          <div class="col-12 col-lg-10 mx-auto">
            <div class="faq-accordion" id="faq-accordion">

              <!-- Item 1 -->
              <div class="faq-item">
                <button class="faq-trigger" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">
                  <span class="faq-num">01</span>
                  <span class="faq-question">What are staking rewards?</span>
                  <ion-icon name="add-outline" class="faq-icon"></ion-icon>
                </button>
                <div id="faq1" class="collapse show" data-bs-parent="#faq-accordion">
                  <div class="faq-answer">
                    Staking rewards are a new class of rewards available for eligible Bantain customers. They are generated by contributing your crypto to Proof of Stake blockchain networks — helping secure the network while you earn passive income automatically.
                  </div>
                </div>
              </div>

              <!-- Item 2 -->
              <div class="faq-item">
                <button class="faq-trigger collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="false" aria-controls="faq2">
                  <span class="faq-num">02</span>
                  <span class="faq-question">How does staking work?</span>
                  <ion-icon name="add-outline" class="faq-icon"></ion-icon>
                </button>
                <div id="faq2" class="collapse" data-bs-parent="#faq-accordion">
                  <div class="faq-answer">
                    Staking lets you earn income by contributing to the Proof of Stake (PoS) network of a crypto asset. When you stake, you make the underlying blockchain more secure and efficient — and in return, the network rewards you with more of that asset. Bantain handles all the technical complexity: running nodes, syncing to the blockchain, and signing blocks on your behalf, while you retain full ownership of your tokens.
                  </div>
                </div>
              </div>

              <!-- Item 3 -->
              <div class="faq-item">
                <button class="faq-trigger collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">
                  <span class="faq-num">03</span>
                  <span class="faq-question">How do I earn staking rewards?</span>
                  <ion-icon name="add-outline" class="faq-icon"></ion-icon>
                </button>
                <div id="faq3" class="collapse" data-bs-parent="#faq-accordion">
                  <div class="faq-answer">
                    Simply deposit an eligible asset into your Bantain staking wallet. We stake, generate blocks, and sign transactions on your behalf — you earn rewards periodically with zero technical effort required on your end.
                  </div>
                </div>
              </div>

              <!-- Item 4 -->
              <div class="faq-item">
                <button class="faq-trigger collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4">
                  <span class="faq-num">04</span>
                  <span class="faq-question">Who is eligible to stake on Bantain?</span>
                  <ion-icon name="add-outline" class="faq-icon"></ion-icon>
                </button>
                <div id="faq4" class="collapse" data-bs-parent="#faq-accordion">
                  <div class="faq-answer">
                    To stake on Bantain, you must hold a minimum of $5,000 worth of the asset you wish to stake. This threshold ensures efficient block validation and maximises the rewards you receive.
                  </div>
                </div>
              </div>

              <!-- Item 5 -->
              <div class="faq-item">
                <button class="faq-trigger collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq5" aria-expanded="false" aria-controls="faq5">
                  <span class="faq-num">05</span>
                  <span class="faq-question">Do I need to buy crypto on Bantain to earn rewards?</span>
                  <ion-icon name="add-outline" class="faq-icon"></ion-icon>
                </button>
                <div id="faq5" class="collapse" data-bs-parent="#faq-accordion">
                  <div class="faq-answer">
                    No. You can earn staking rewards on any eligible assets you hold, regardless of where you purchased them. Simply send your assets from an external wallet to your Bantain staking wallet — transfers are free.
                  </div>
                </div>
              </div>

              <!-- Item 6 -->
              <div class="faq-item">
                <button class="faq-trigger collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq6" aria-expanded="false" aria-controls="faq6">
                  <span class="faq-num">06</span>
                  <span class="faq-question">What's the difference between a staking wallet and a normal wallet?</span>
                  <ion-icon name="add-outline" class="faq-icon"></ion-icon>
                </button>
                <div id="faq6" class="collapse" data-bs-parent="#faq-accordion">
                  <div class="faq-answer">
                    A staking wallet is purpose-built for maximising yield. Unlike a normal wallet that simply stores assets, our staking wallet actively puts your crypto to work in institutional-grade staking pools — giving you the best possible growth on your locked-in assets.
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>
    <!-- ***** FAQ Area End ***** -->

    <!-- ***** Download Area Start ***** -->
    <section class="section download-area overlay-dark ptb_100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-9">
            <!-- Download Text -->
            <div class="download-text text-center">
              <h2 class="text-white">Bridging the Gap between Crypto and Users</h2>
              <p class="text-white my-3 d-none d-sm-block">
                Mining crypto is hard to do on your own. With Bantain, it takes just a couple taps
              </p>
              <p class="text-white my-3 d-block d-sm-none">
                Mining crypto is hard to do on your own. With Bantain, it takes just a couple taps
              </p>
              <!-- Store Buttons -->
              <div class="button-group store-buttons d-flex justify-content-center">
                <a href="/desktop" target="_self" class="btn btn-bordered mt-4">Go to Wallet</a>
                <!--                            <a href="#">-->
                <!--                                <img src="../../assets/parent/img/icon/google-play.png" alt="">-->
                <!--                            </a>-->
                <!--                            <a href="#">-->
                <!--                                <img src="../../assets/parent/img/icon/app-store.png" alt="">-->
                <!--                            </a>-->
              </div>
              <span class="d-inline-block text-white fw-3 font-italic mt-3">* Best viewed on mobile devices</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ***** Download Area End ***** -->

    <!--====== Contact Area Start ======-->
    <section id="contact" class="contact-area ptb_100">
      <div class="container">

        <!-- Header -->
        <div class="row align-items-end justify-content-between mb-5">
          <div class="col-12 col-lg-5">
            <span class="features-badge mb-3 d-inline-flex align-items-center gap-2">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
              Get In Touch
            </span>
            <h2 class="features-heading">
              Speak To<br>
              <span class="features-heading-accent">Us</span> Anytime
            </h2>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
            <p class="features-sub mb-0">
              Whether you have questions, need support, or just want to say hello — our team is ready to help. Reach out through any of the channels below.
            </p>
          </div>
        </div>

        <div class="row g-5 align-items-start">

          <!-- Left: contact info -->
          <div class="col-12 col-lg-5">
            <div class="contact-info-list">

              <div class="contact-info-item">
                <div class="contact-info-icon">
                  <ion-icon name="location-outline"></ion-icon>
                </div>
                <div class="contact-info-body">
                  <div class="contact-info-label">Our Offices</div>
                  <div class="contact-info-value">
                    115 Hampstead Road, London, England, NW1 3EE<br>
                    Langstrasse 136, 8004 Zürich, Switzerland<br>
                    Tokyo, Tokyo Japan
                  </div>
                </div>
              </div>

              <div class="contact-info-item">
                <div class="contact-info-icon">
                  <ion-icon name="logo-whatsapp"></ion-icon>
                </div>
                <div class="contact-info-body">
                  <div class="contact-info-label">WhatsApp</div>
                  <a class="contact-info-value contact-info-link" href="https://wa.me/447900261731">
                    (+44) 7900 261731 &nbsp;·&nbsp; (+1) 941 278 9632
                  </a>
                </div>
              </div>

              <div class="contact-info-item">
                <div class="contact-info-icon">
                  <ion-icon name="mail-outline"></ion-icon>
                </div>
                <div class="contact-info-body">
                  <div class="contact-info-label">Email</div>
                  <a class="contact-info-value contact-info-link" href="mailto:support@bantainapp.com">
                    support@bantainapp.com
                  </a>
                </div>
              </div>

              <!-- Availability badge -->
              <div class="contact-available">
                <span class="contact-available-dot"></span>
                Support available Monday – Friday, 9am – 6pm GMT
              </div>

            </div>
          </div>

          <!-- Right: form -->
          <div class="col-12 col-lg-7">
            <div class="contact-form-card">
              <contact-form/>
            </div>
          </div>

        </div>
      </div>
    </section>
    <!--====== Contact Area End ======-->

    <!--====== Height Emulator Area Start ======-->
    <!-- <div class="height-emulator d-none d-lg-block"></div> -->
    <!--====== Height Emulator Area End ======-->
  </div>
</template>

<script>
import contactForm from '../../components/contactForm';
import coinsImg from "../../assets/parent/img/bg/coins.png";

export default {
  name: 'Home',
  data(){
    return {
      coinsImg
    }
  },
  components: {
    contactForm
  }
};
</script>

<style scoped>

@media screen and (min-width: 320px){
  .overlay-dark.custom{
    background-size: contain;
    background-attachment: scroll;
  }
}
@media screen and (min-width: 768px){
  .overlay-dark.custom{
    background-size: 80%;
  }
}
.overlay-dark.custom::after{
  background: none!important;
}
</style>